export default __webpack_public_path__ + "static/media/photo-01.c3e1442f.jpeg";